import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

/** Coquille de l'application : sidebar fixe + zone de contenu (pages routées). */
export default function Layout() {
  return (
    <div className="shell">
      <Sidebar />
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}
